import { gql } from "@apollo/client"

const GET_COMP_FOR_GEN = gql`
  query GetComponent($route: String!, $culture: String!, $first: Int = 100, $after: String) {
    components: contentDescendantsByAbsoluteRoute(
      route: $route
      culture: $culture
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          name
          id
          url
          absoluteUrl
          contentType {
            alias
          }
          children {
            id
            contentType {
              alias
            }
          }
          parent {
            name
            level
            parent {
              level
              name
              parent {
                level
                name
                parent {
                  level
                  name
                  parent {
                    level
                    name
                    parent {
                      name
                      level
                    }
                  }
                }
              }
            }
          }
          properties {
            propertyName: alias
            propertyValue: value {
              ...propertyValuesComponent
            }
            #editorAlias
          }
        }
      }
    }
  }

  fragment propertyEditorsComponent on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPickerComp
    ...memberPickerComponent
    ...multiUrlPicker
    ...nestedContentComponent
    ...richTextEditorComponent
    ...unsupportedEditor
    valueType: model
  }

  fragment dateTimePicker on PropertyValue {
    ... on BasicDateTimePicker {
      dateTime: value
    }
  }

  fragment basicValue on PropertyValue {
    ... on BasicPropertyValue {
      value: value
    }
  }

  fragment contentPicker on PropertyValue {
    ... on BasicContentPicker {
      contentList {
        id
        absoluteUrl
        key
        name
        url
        urlSegment
      }
    }
  }

  fragment label on PropertyValue {
    ... on BasicLabel {
      label: value
    }
  }

  fragment mediaPickerComp on PropertyValue {
    ... on MintMediaPicker {
      mediaItems {
        id
        url
        altText
      }
    }
  }

  fragment memberPickerComponent on PropertyValue {
    ... on BasicMemberPicker {
      members {
        id
        name
        properties {
          alias
          value {
            ...memberPropertyEditorsComponent
          }
          editorAlias
        }
      }
    }
  }

  fragment memberPropertyEditorsComponent on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPickerComp
    ...slimMemberPicker
    ...multiUrlPicker
    ...nestedContentComponent
    ...richTextEditorComponent
    ...unsupportedEditor
    model
  }

  fragment slimMemberPicker on PropertyValue {
    ... on BasicMemberPicker {
      members {
        id
        name
      }
    }
  }

  fragment multiUrlPicker on PropertyValue {
    ... on BasicMultiUrlPicker {
      links {
        name
        target
        type
        url
      }
    }
  }

  fragment nestedContentComponent on PropertyValue {
    ... on BasicNestedContent {
      elements {
        properties {
          alias
          value {
            ...nestedContentPropertyEditorsComponent
          }
          editorAlias
        }
      }
    }
  }

  fragment nestedContentPropertyEditorsComponent on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPickerComp
    ...slimMemberPicker
    ...multiUrlPicker
    ...richTextEditorComponent
    ...unsupportedEditor
    model
  }

  fragment richTextEditorComponent on PropertyValue {
    ... on BasicRichText {
      richText: value
      sourceValue
    }
  }

  fragment unsupportedEditor on PropertyValue {
    ... on BasicUnsupportedPropertyValue {
      message
    }
  }

  fragment blockEditorComponent on PropertyValue {
    ... on BasicBlockListModel {
      blocks {
        blockType: contentAlias
        #settingsAlias
        properties: contentProperties {
          propertyName: alias
          #editorAlias
          propertyValue: value {
            ...propertyEditorsComponent
            ... on BasicBlockListModel {
              blocks {
                blockType: contentAlias
                properties: contentProperties {
                  propertyName: alias
                  #editorAlias
                  propertyValue: value {
                    ...propertyEditorsComponent
                    ... on BasicBlockListModel {
                      blocks {
                        blockType: contentAlias
                        properties: contentProperties {
                          propertyName: alias
                          #editorAlias
                          propertyValue: value {
                            ...propertyEditorsComponent
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment blockGridEditorComponent on PropertyValue {
    ... on BasicBlockGridModel {
      gridColumns
      blocks {
        contentProperties {
          value {
            ...propertyEditorsComponent
          }
        }
        settingsProperties {
          value {
            ...propertyEditorsComponent
          }
        }
        columnSpan
        rowSpan
        areas {
          alias
          rowSpan
          columnSpan
          blocks {
            contentProperties {
              value {
                ...propertyEditorsComponent
              }
            }
            settingsProperties {
              value {
                ...propertyEditorsComponent
              }
            }
            columnSpan
            rowSpan
            areas {
              alias
              rowSpan
              columnSpan
            }
          }
        }
      }
    }
  }

  fragment propertyValuesComponent on PropertyValue {
    ...propertyEditorsComponent
    ...blockEditorComponent
    ...blockGridEditorComponent
  }
`

export default GET_COMP_FOR_GEN
